import React from 'react'
import Skeleton from 'react-loading-skeleton'
const SkeletonConversations = () => {
  return (
    <>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="conversation">
            <div className="conversationLeft">
                <div className="conversationProfileImgWrapper">
                <Skeleton className='conversationProfileImg' />
                </div>
            </div>
            <div className="conversationRight">
                <div className="conversationRightContent">
                    <div className="conversationTopRight">
                        <p className="conversationUsername" style={{ width: '60%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '25%'}}>
                            <Skeleton />
                        </p>
                    </div>
                    <div className="conversationBottomRight">
                        {/* <p className="lastMessage">{latestMessage.text}</p> */}
                        <p className="conversationUsername" style={{ width: '70%' }}><Skeleton /></p>
                        <p className="conversationUsername" style={{ width: '10%' }}>
                            <Skeleton />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default SkeletonConversations